import { useDiaryByIdQuery } from "@/features/diaries/api/diaryQueries";

const useCountDueObservations = (diaryId: string) => {
	const { data: diary } = useDiaryByIdQuery(diaryId);

	return diary?.observations_view.reduce(
		(total, observation) => total + (observation?.due_entries?.length || 0),
		0,
	);
};

export default useCountDueObservations;
